module.exports = __webpack_public_path__ + "static/media/investor-tiny.d18327fd.svg";